import axios from "../api";
//import { error } from "console";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

const EditarCierreDia = () =>{
    const {id} = useParams();
    const history = useHistory();
    const [cierre, setCierre] = useState(null);
    const [originalCierre, setOriginalCierre] = useState(null);
    const [showConfirmacion, setShowConfirmacion] = useState(false);
    const [cambios, setCambios] = useState({});

    useEffect(() => {
        const fetchCierre = async () => {
            try {
                const response = await axios.get(`/cierres-dia/${id}`);
                setCierre(response.data);
                setOriginalCierre(response.data);
            } catch (error) {
                console.error('Error al obtener el cierre:', error);
                alert('Error al cargar los datos');
            }
        };
        fetchCierre();
    }, [id]);     

    const getCambios = () => {
        const cambiosDetectados = {};
        Object.keys(cierre).forEach(key => {
            if (cierre[key] !== originalCierre[key]) {
                cambiosDetectados[key] = {
                    anterior: originalCierre[key],
                    nuevo: cierre[key]
                };
            }
        });
        return cambiosDetectados;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const cambiosDetectados = getCambios();
        
        if(Object.keys(cambiosDetectados).length > 0){
            let mensaje = 'Vas a Modificar los siguientes campos:\n';
            for(const [campo, valores] of Object.entries(cambiosDetectados)){
                mensaje += `${campo.replace(/_/g, ' ').toUpperCase()}: Anterior: ${valores.anterior}, Nuevo: ${valores.nuevo}\n`;
            }

            mensaje += '¿Deseas continuar?';
            const confirmado = window.confirm(mensaje);
            if(confirmado){
                await confirmarGuardado();
            }else{
                alert('Modificacion cancelada');
            }
        }else{
            alert('No se han detectado cambios');
        }    
    };

    const confirmarGuardado = async () => {
        try{
            await axios.patch(`/cierres-dia/${id}`, cierre);
            setShowConfirmacion(false);
            history.push('/Planillas/cierredia', { cierre });
        }catch(error){
            console.error('Error al actualizar:', error);
            alert('Error al actualizar el cierre');
        }
    };

    const handleChange = (e) => {
        const {name, value} = e.target;
        setCierre(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const formatFecha = (fecha) => {
        if(!fecha) return '';
        return new Date(fecha).toLocaleDateString('es-CO',{
            year: 'numeric',
            mont: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };
   
    if (!cierre) return <div>Cargando...</div>;

    return (
        <div className="editar-cierre-container">
            <h2>Editar Cierre de Día ID {id}</h2>
            <form onSubmit={handleSubmit} className="editar-form">
                <div className="form-row">
                    <div className="form-group">
                        <label>Total Efectivo:</label>
                        <input
                            type="number"
                            name="totalEfectivo"
                            value={cierre.totalEfectivo}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label>Total Tarjeta:</label>
                        <input
                            type="number"
                            name="totalTc"
                            value={cierre.totalTc}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group">
                        <label>Estado:</label>
                        <select
                            name="estado"
                            value={cierre.estado}
                            onChange={handleChange}
                            className="form-control"
                        >
                            <option value="ACTIVO">ACTIVO</option>
                            <option value="INACTIVO">INACTIVO</option>
                        </select>
                    </div>
                </div>
                <div className="form-buttons">
                    <button type="submit" className="guardar-btn">Guardar Cambios</button>
                    <button
                        type="button"
                        className="cancelar-btn"
                        onClick={() => history.push('/Planillas/cierredia')}
                    >
                        Cancelar
                    </button>
                </div>
            </form>
        </div>
    );
    
};
export default EditarCierreDia;